// src/pages/Careers.tsx
import "./styles/careers.css";

export default function Careers() {
  return (
    <section className="careers-page">
      <h1 className="careers-title">Careers</h1>
      <p className="careers-message">
        This page is not available at this time. Please check back later.
      </p>
    </section>
  );
}
